import { useTranslation } from 'react-i18next';
import { changeLanguage, LANGUAGES, type Language } from '../i18n';

/** Selector ES | EN: cambia todos los textos al instante y recuerda la elección. */
export function LanguageSwitch({ onChange }: { onChange?: (lang: Language) => void }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage as Language;
  return (
    <div className="langswitch" role="group" aria-label={t('common.language')}>
      {LANGUAGES.map((lang) => (
        <button
          key={lang}
          type="button"
          className="btn sm"
          aria-pressed={current === lang}
          data-lang={lang}
          onClick={() => {
            if (onChange) onChange(lang);
            else void changeLanguage(lang);
          }}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
